import { useUserTier } from '@trustpad/launchpad';
import * as React from 'react';
import { useUserExtraData } from '~common/providers/useUserExtraData';
import { StandardCard } from '~common/UI';
import { IS_DEV } from '~config/constants';
import { DHAdmin } from '~features/diamondHands/DHAdmin';
import { DHDistributionTimeline } from '~features/diamondHands/DHDistributionTimeline';
import { DHEligibilityRules } from '~features/diamondHands/DHEligibilityRules';
import { DHStatusCountdown } from '~features/diamondHands/DHStatusCountdown';
import { DHUserRewards } from '~features/diamondHands/DHUserRewards';
import { DiamondHandsTotalStats } from '~features/diamondHands/DiamondHandsOverview';
import {
  DHDistributionStatus,
  useDHDistribution,
} from '~features/diamondHands/useDHDistribution';
import { useDHTreasury } from '~features/diamondHands/useDHTreasury';
import { TierName } from '~features/tiers';
import { ActionButton, Alert, Button } from '~features/ui';

// TODO: the table with distributions
export function DiamondHandsPage() {
  const { tierState } = useUserTier();
  const { distribution, dhUser, register, isLoading, refresh } =
    useDHDistribution();
  const { rewards, tokenPools } = useDHTreasury();
  const { contributions } = useUserExtraData();

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <StandardCard className="space-y-3">
        <h3 className="mb-3 text-gray-100">Distribution</h3>

        <div>
          Current level: <TierName name={tierState.tierId} />{' '}
          {tierState.tier.aag ? (tierState.tier.vip ? 'SAAG' : 'AAG') : ''}
          <br />
          Has rewards: <b>{dhUser.hasReward ? 'Yes' : 'No'}</b> <br />
          DH25 eligible: <b>{dhUser.userDH25Share > 0 ? 'Yes' : 'No'}</b> <br />
          Retro rewards eligible: <b>
            {dhUser.isRetroEligible ? 'Yes' : 'No'}
          </b>{' '}
          <br />
          Registered: <b>{dhUser.isRegistered ? 'Yes' : 'No'}</b>
        </div>

        <DHEligibilityRules />

        <DHDistributionTimeline distribution={distribution} />
        <DHStatusCountdown distribution={distribution} />

        {dhUser.hasReward && !dhUser.isRegistered && (
          <Alert type="warning">Not registered</Alert>
        )}

        <div className="bg-dark3 -mx-5 p-5">
          <DHUserRewards
            dhUser={dhUser}
            distribution={distribution}
            rewards={rewards}
            contributions={contributions}
          />
        </div>

        {distribution.status !== DHDistributionStatus.Registration ? (
          <></>
        ) : dhUser.isRegistered ? (
          <Button disabled>Registered ✅</Button>
        ) : dhUser.hasReward ? (
          <ActionButton
            onClick={register}
            isLoading={isLoading}
            isDisabled={isLoading}>
            Register
          </ActionButton>
        ) : (
          <Button disabled>Not eligible</Button>
        )}
      </StandardCard>

      <StandardCard>
        <h3 className="mb-3 text-gray-100">Total rewards</h3>

        <DiamondHandsTotalStats
          rewards={rewards}
          distribution={distribution}
          tokenPools={tokenPools}
        />
      </StandardCard>

      {IS_DEV && (
        <StandardCard>
          <h3 className="mb-3 text-gray-100">Admin</h3>

          <DHAdmin
            dhUser={dhUser}
            distribution={distribution}
            refresh={refresh}
          />
        </StandardCard>
      )}

      {false && (
        <div className="col-span-2">
          <StandardCard>
            <h3 className="mb-3 text-gray-100">Previous distributions</h3>
            Table with previous distributions (wide)
          </StandardCard>
        </div>
      )}
    </div>
  );
}
